<div
  class="request-own-data-modal-wrapper"
  role="dialog"
  aria-modal="true"
  aria-labelledby="request-own-data-heading"
  aria-describedby="request-own-data-description">
  <button
    type="button"
    class="close-button-wrapper"
    (click)="close()"
    [attr.aria-label]="'COMMON.ACTION.CLOSE' | translate">
    <mat-icon aria-hidden="true">close</mat-icon>
  </button>

  <app-cr-header class="header" [headingLevel]="2">
    {{ 'REQUEST_OWN_DATA_MODAL.REQUEST_OWN_DATA' | translate }}
  </app-cr-header>

  <div *ngIf="step === 'INFO'" id="request-own-data-description" class="step" aria-live="polite">
    <p class="text" [innerHTML]="'COMMON.CONFIRMATION.ARE_YOU_SURE_REQUEST_OWN_DATA' | translate"></p>
  </div>

  <div *ngIf="step === 'SENDING'" class="step">
    <div class="spinner" role="status" aria-live="polite">
      <span class="sr-only">
        {{ 'COMMON.LAYOUT.LOADING' | translate }}
      </span>

      <mat-spinner [diameter]="75" [attr.aria-hidden]="true"></mat-spinner>
    </div>
  </div>

  <div *ngIf="step === 'REQUEST_SENT'" class="step">
    <p class="text" [innerHTML]="'REQUEST_OWN_DATA_MODAL.REQUEST_SENT' | translate"></p>
  </div>

  <div *ngIf="step === 'ERROR'" class="step">
    <p class="text" [innerHTML]="'REQUEST_OWN_DATA_MODAL.REQUEST_SENT_ERROR' | translate"></p>
  </div>

  <div *ngIf="step !== 'SENDING'" class="action-buttons">
    <button mat-raised-button type="button" (click)="close()">
      {{ 'COMMON.ACTION.CANCEL' | translate }}
    </button>

    <button *ngIf="step === 'INFO'" mat-raised-button color="primary" type="button" (click)="confirm()">
      {{ 'REQUEST_OWN_DATA_MODAL.SEND_REQUEST' | translate }}
    </button>

    <button
      *ngIf="step === 'REQUEST_SENT' || step === 'ERROR'"
      mat-raised-button
      color="primary"
      type="button"
      (click)="close()">
      {{ 'COMMON.ACTION.CLOSE' | translate }}
    </button>
  </div>
</div>
